// NOTE: This project now uses the krysalis_backend API from a separate repository.
// The backend code in this repository is deprecated and kept for reference only.
// Configure REACT_APP_API_URL environment variable to point to your krysalis_backend instance.
// Default assumes krysalis_backend is running on the same port for local development.
const DEFAULT_API_URL = 'http://localhost:8000/api/v1';

/**
 * Resolve the API base URL for axios.
 *
 * HTTPS pages (e.g. https://krysalis.ai) cannot call an `http://` API — browsers block that as
 * mixed content and axios surfaces it as "Network Error". When the SPA is served over TLS and
 * REACT_APP_API_URL is missing or still an http:// bake (common when a shell env overrides
 * .env.production during `npm run build`), use same-origin `/api/v1` (nginx proxies to the API).
 */
export function resolveApiBaseUrl(
  envApiUrl: string | undefined = process.env.REACT_APP_API_URL,
  location: Pick<Location, 'protocol' | 'origin'> | undefined =
    typeof window !== 'undefined' ? window.location : undefined
): string {
  const fromEnv = (envApiUrl || '').trim();
  if (location?.protocol === 'https:') {
    if (!fromEnv || fromEnv.startsWith('http://')) {
      return `${location.origin}/api/v1`;
    }
  }
  return fromEnv || DEFAULT_API_URL;
}

export const API_BASE_URL = resolveApiBaseUrl();

const deriveWebsocketUrl = (httpUrl: string) => {
  if (httpUrl.startsWith('https://')) {
    return `wss://${httpUrl.slice('https://'.length)}`;
  }

  if (httpUrl.startsWith('http://')) {
    return `ws://${httpUrl.slice('http://'.length)}`;
  }

  return httpUrl;
};

const envWsUrl = process.env.REACT_APP_WS_URL;
export const WS_BASE_URL = envWsUrl && envWsUrl.trim().length > 0 ? envWsUrl : deriveWebsocketUrl(API_BASE_URL);

/**
 * Bridge Sessions API URL for Bridge Session and Control Bridge.
 * Uses backend at API_BASE_URL/bridge-sessions (PostgreSQL).
 * Override with REACT_APP_LOCAL_BRIDGE_API_URL if pointing to a different backend instance.
 */
const envLocalBridgeUrl = process.env.REACT_APP_LOCAL_BRIDGE_API_URL;
export const LOCAL_BRIDGE_API_URL =
  envLocalBridgeUrl && envLocalBridgeUrl.trim().length > 0
    ? envLocalBridgeUrl.trim()
    : `${API_BASE_URL.replace(/\/$/, '')}/bridge-sessions`;

/** Thin kryspace read API for company-model render manifests (Steve lane / Seq 4). */
const envKryspaceReadUrl = process.env.REACT_APP_KRYSPACE_READ_API_URL;
export const KRYSPACE_READ_API_URL =
  envKryspaceReadUrl && envKryspaceReadUrl.trim().length > 0
    ? envKryspaceReadUrl.trim().replace(/\/$/, '')
    : '';

/** Local dev: serve static mock manifest when read API is not configured. */
export const RENDER_SURFACE_DEV_MOCK =
  process.env.REACT_APP_RENDER_SURFACE_DEV_MOCK === 'true';
